import React from "react";
import { Link } from "react-router-dom";

const WebinarItem = (props) => {
  return (
    <Link to={`/Webinar/InnerWebinar/${props.data.id}`} className="webinarItem">
      <div className="picture">
        <img src={props.data.cover_image} />
      </div>
      <div className="details">
        <div className="desc">
          <span>{props.data.title}</span>
          <span>درباره وبینار:</span>
          <p dangerouslySetInnerHTML={{ __html: props.data.description }}></p>
        </div>
        <div className="time">
          <span>
            تاریخ شروع: <b>{props.data.string_starttime}</b>
          </span>
          <span>
            زمان برگزاری: <b>{props.data.string_eventtime}</b>
          </span>
        </div>
      </div>
      <div className="seeMore">
        <Link to={`/Webinar/InnerWebinar/${props.data.id}`}>مشاهده جزئیات</Link>
      </div>
    </Link>
  );
};

export default WebinarItem;
